import React, { useMemo } from "react"
import { Box, Container, SimpleGrid } from "@chakra-ui/react"
import { GridItem } from "./GridItem"
import { useImage } from "@hooks/useImage"

export type GridProps = { items: GatsbyTypes.SanityObjectSectionGrid[] }

const Grid: React.FC<GridProps> = ({ items: rawItems }) => {
  const { getGatsbyImage } = useImage()

  const items = useMemo(
    () =>
      rawItems?.map(item => ({
        ...item,
        key: item?._key,
        image: getGatsbyImage(item?.image),
        text: item?.text,
      })) || [],
    [getGatsbyImage, rawItems]
  )

  return items?.length > 0 ? (
    <Container mt={[10, 4]} mb={[10, 5]} maxW="container.xl" minW={"unset"}>
      <Box>
        <SimpleGrid columns={[1, items?.length]} spacingX={[3, 4]} spacingY={4} w="full" h="full">
          {items?.map(item => <GridItem key={item?.key} item={item} />)}
        </SimpleGrid>
      </Box>
    </Container>
  ) : null
}

export default Grid
